<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill="#e71c27" d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1Zm0 13A6 6 0 1 1 8 2a6 6 0 0 1 0 12Z"/>
  <path d="M8 9.5a.47.47 0 0 0 .5-.5V4.2a.5.5 0 1 0-1 0V9a.47.47 0 0 0 .5.5Zm0 1.3a.7.7 0 1 0 .7.7.68.68 0 0 0-.7-.7Z"/>
</svg>
